import React from "react";
import { Box, Typography, Button, Dialog } from "@mui/material";
import Image from "@/components/image";
import CongratsIcon from "@/assets/illustrations/cc_task.gif";

import { useTheme } from "@emotion/react";
import { useStores } from "../../../hooks/useStores";
import { observer } from "mobx-react";

const CareerClimbCompletionModal = observer(() => {
  const theme = useTheme();
  const { sessionStore } = useStores();
  const { careerClimbCompletionData, newlyCompletedAwards } = sessionStore;

  if (!careerClimbCompletionData || newlyCompletedAwards.length > 0) {
    // Don't display career climb and award at the same time — award takes precedence.
    return null;
  }

  const handleBackNavigation = () => {
    // Check if a previous path is available in location.state
    sessionStore.removeCareerClimbCompletionData();
  };

  const careerClimb = careerClimbCompletionData[0] || {
    name: "Unknown",
  };

  return (
    <Dialog open={true} onClose={handleBackNavigation}>
      <Box
        sx={{
          textAlign: "center",
          margin: "50px",
        }}
      >
        <div id="report-6" style={{ width: "70%", height: "auto" }}></div>
        <Typography color="secondary.main" variant="h3" fontFamily="Nunito">
          Career Climb Complete!
        </Typography>
        <Box>
          <Image
            alt="scrolling check list all completed"
            src={CongratsIcon}
            sx={{
              width: "128px",
              height: "128px",
            }}
          />
        </Box>

        <Typography variant="h6" fontFamily="ProximaNova Bold">
          You completed{" "}
          <span style={{ color: theme.palette.secondary.main }}>
            {careerClimb.name}
          </span>
        </Typography>
        <Typography variant="h6" fontFamily="ProximaNova Bold">
          Look at you go...
        </Typography>

        <Button
          color="secondary"
          variant="contained"
          sx={{
            width: "100%",
            height: "48px",
            marginTop: "80px",
          }}
          onClick={handleBackNavigation}
        >
          Keep Climbing
        </Button>
      </Box>
    </Dialog>
  );
});

export default CareerClimbCompletionModal;
